(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["f24-home-b2b"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function buildMsg(form) {
      var g = function (n) {
        var el = form.querySelector('[name="' + n + '"]');
        return el ? el.value.trim() : '';
      };
      var L = [
        '*Cotización Ferre24*',
        '— — —',
        'Nombre: ' + (g('nombre') || '—'),
        'Empresa / proyecto: ' + (g('empresa') || '—'),
        'Equipo que necesito: ' + (g('equipo') || '—'),
        'Cantidad: ' + (g('cantidad') || '—'),
        'Ciudad: ' + (g('ciudad') || '—'),
        'Lo necesito: ' + (g('cuando') || '—')
      ];
      return L.join('\n');
    }

    function wire(form) {
      if (form.dataset.f24Wired === '1') return;
      form.dataset.f24Wired = '1';
      var err = form.querySelector('.f24h-b2b__err');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var bad = null;
        ['nombre', 'equipo'].forEach(function (n) {
          var el = form.querySelector('[name="' + n + '"]');
          var field = el ? el.closest('.f24h-b2b__field') : null;
          if (el && !el.value.trim()) {
            if (field) field.classList.add('is-err');
            if (!bad) bad = el;
          } else if (field) {
            field.classList.remove('is-err');
          }
        });
        if (bad) {
          if (err) err.hidden = false;
          bad.focus();
          return;
        }
        if (err) err.hidden = true;
        var wa = (form.dataset.wa || '').replace(/[^0-9]/g, '');
        var url = 'https://wa.me/' + wa + '?text=' + encodeURIComponent(buildMsg(form));
        if (window.F24_STAMP) { try { url = window.F24_STAMP(url); } catch (e) {} } window.open(url, '_blank', 'noopener');
      });
    }

    function init() {
      document.querySelectorAll('.f24h-b2b__form').forEach(wire);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
